import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';
import Suggestions from 'static/script/app/models/suggestions';
import SuggestionsParser from 'static/script/app/data/suggestions-parser';
import _ from 'static/script/libs/underscore';

let SearchSuggestionService = function () {

    this._isCanceled = false;

    this._cancel = function () {
        this._isCanceled = true;
    };

    this._focusin = function () {
        this._isCanceled = false;
    };

    this._query = function (evt, payload) {
        if(!this._isCanceled){
            if ((payload.query || '').length < 2) {
                let emptyData = {
                    query: payload.query,
                    searches: [],
                    shops: []
                };
                this._handleResult(emptyData);
                return;
            }

            let success = function (data) {
                if(!this._isCanceled){
                    this._handleResult(data);
                }
            };

            this.ajaxRequest = this._get({
                url: '/search/suggestions',
                data: { q: payload.query.toString() },
                success: success.bind(this),
                requestId: 'autocomplete',
                noShowError: true,
                cache: true
            }).fail(function () {
                console.log('defer fail. request probably aborted');
            });
        }
    };

    this._handleResult = function (data) {
        let suggestions = new SuggestionsParser().parse(data);
        let payload = { 'suggestions': suggestions, query: data.query };
        this.trigger(document, 'data:search-suggestion:on-suggestion-complete', payload);
    };

    this.after('initialize', function () {
        this.on(document, 'ui:site-search:on-search-submit', this._cancel);
        this.on(document, 'ui:site-search:on-search-field-input', _.debounce(this._query, 400));
        this.on(document, 'ui:site-search:on-search-field-blur', this._cancel);
        this.on(document, 'ui:site-search:on-search-field-focusin', this._focusin);
    });

};

module.exports = defineComponent.component(SearchSuggestionService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/search-suggestion-service.js